import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="account";
export function queryByName(parameter) {
    return axios({
    url: `/ws/${moduleName}/queryByName`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
// export function selectAll(parameter) {
//   console.log("params:", parameter)
//   return axios({
//     url: `/ws/${moduleName}`,
//     method: 'get',
//     params: parameter,
//     paramsSerializer: params => {
//       return qs.stringify(params, { indices: false })
//     }
//   })
// }
//
// export function insert(parameter){
//   console.log("data:",parameter)
//   return axios({
//     url: `/ws/${moduleName}`,
//     method: 'post',
//     data:parameter
//   })
// }
//
export function selectOne(id) {
  console.log("id:", id)
  return axios({
    url: `/ws/${moduleName}/${id}`,
    method: 'get',
  })
}

export function listAll(){
  return axios({
    url: `/ws/${moduleName}/listAll`,
    method: 'get',
  })
}

export default {
  // insert,
  // selectAll,
  selectOne,
  queryByName,
  listAll
}